module.exports = __webpack_public_path__ + "static/media/3.02ee0da3.jpg";